import gql from 'graphql-tag'

export const GET_CUSTOMER_CATEGORY_LIST_CUSTOM_PRICE = gql`
query ($ids: [ID!], $productIds: [ID!])  {
  customerCategoryList(ids: $ids) {
    nodes {
      id
      name
      categoryProductList(productIds: $productIds) {
        nodes {
          id
          customPrice
          product {
            id
            name
            price
          }
        }
      }
    }
  }
}
`

export default {
  GET_CUSTOMER_CATEGORY_LIST_CUSTOM_PRICE
}
